import { data } from "jquery";
import React from "react";

export function ModalDetailUser(props) {
    return (
        <div>
            <button id="openModel" type="button" class="btn btn-primary" data-toggle="modal" data-target="#exampleModal" hidden>
                Launch demo modal
            </button>

            <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalLabel">Modal title</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div className="group-form">
                                <b>Nombre: </b>
                                <label>{props.data ? props.data.name : ''}</label>
                            </div>
                            <div className="group-form">
                                <b>Email: </b>
                                <label>{props.data ? props.data.email : ''}</label>
                            </div>
                            <div className="group-form">
                                <b>Edad: </b>
                                <label>{props.data ? props.data.age : ''}</label>
                            </div>
                            <div className="group-form">
                                <b>Identificaci&oacute;n: </b>
                                <label>{props.data ? props.data.identification : ''}</label>
                            </div>
                            <div className="group-form">
                                <b>Ciudad: </b>
                                <label>{props.data ? props.data.city : ''}</label>
                            </div>
                            <div className="group-form">
                                <b>Direccí&oacute;n: </b>
                                <label>{props.data ? props.data.address : ''}</label>
                            </div>
                            <div className="group-form">
                                <b>N&uacute;mero de contacto: </b>
                                <label>{props.data ? props.data.contact : ''}</label>
                            </div>
                            <div className="group-form">
                                <b>Enrolador: </b>
                                <label>{props.data ? props.data.enroller : ''}</label>
                            </div>
                            <div className="group-form">
                                <b>Enrolador n&uacute;mero: </b>
                                <label>{props.data ? props.data.enrollerNumber : ''}</label>
                            </div>
                            <div className="group-form">
                                <b>Contacto de emergenc&iacute;a: </b>
                                <label>{props.data ? props.data.emergencyName : ''}</label>
                            </div>
                            <div className="group-form">
                                <b>N&uacute;mero de emergenc&iacute;a: </b>
                                <label>{props.data ? props.data.emergencyNumber : ''}</label>
                            </div>
                            <div className="group-form">
                                <b>G&eacute;nero: </b>
                                <label>{props.data ? props.data.gender : ''}</label>
                            </div>
                            <div className="group-form">
                                <b>¿Está embarazada?: </b>
                                <label>{props.data ? props.data.pregnant : ''}</label>
                            </div>
                            <div className="group-form">
                                <b>¿Has sufrido alguno de estos síntomas durante los últimos 8 días?: </b>
                                {props.data ? JSON.parse(props.data.optionSymptom).map(u => <span className="tags">{u}</span>) : <label>NA</label>}
                            </div>
                            <div className="group-form">
                                <b>Opciones COVID: </b>
                                {props.data ? JSON.parse(props.data.optionCovid).map(u => <span className="tags">{u}</span>) : <label>NA</label>}
                            </div>
                            <div className="group-form">
                                <b>Vacunas: </b>
                                {props.data && props.data.vaccine ? JSON.parse(props.data.vaccine).map(u => <span className="tags">{u}</span>) : <label>NA</label>}
                            </div>
                            <div className="group-form">
                                <b>Otra vacuna: </b>
                                <label>{props.data ? props.data.anotherVaccine : ''}</label>
                            </div>
                            <div className="group-form">
                                <b>Cuantas dosis: </b>
                                <label>{props.data ? props.data.dosis : ''}</label>
                            </div>
                            <div className="group-form">
                                <b>Horas de sueño: </b>
                                <label>{props.data ? props.data.sleep : ''}</label>
                            </div>
                            <div className="group-form">
                                <b>¿Ha recibido consejería o terapia psicológica antes del último año?: </b>
                                <label>{props.data ? props.data.therapyYearAgo : ''}</label>
                            </div>
                            <div className="group-form">
                                <b>¿Recibe consejería o terapia psicológica en la actualidad?: </b>
                                <label>{props.data ? props.data.currentTherapy : ''}</label>
                            </div>
                            <div className="group-form">
                                <b>¿Ha sido hospitalizado para atender su salud mental?: </b>
                                <label>{props.data ? props.data.hospitalized : ''}</label>
                            </div>
                            <div className="group-form">
                                <b>¿Le han recetado alguna vez, o se encuentra actualmente tomando medicinas para el tratamiento de dolencias emocionales, tales como: compazine, haldol, navane, proxilin, prozac, stelazine, triavil?: </b>
                                <label>{props.data ? props.data.takeMedication : ''}</label><br />
                                <label>{props.data ? props.data.anotherMedication : ''}</label>
                            </div>
                            <div className="group-form">
                                <b>¿Ha sufrido un colapso nervioso diagnosticado por un profesional de la salud?: </b>
                                <label>{props.data ? props.data.nervousCollapse : ''}</label><br />
                                <label>{props.data ? props.data.anotherNervous : ''}</label>
                            </div>
                            <div className="group-form">
                                <b>¿Tiene alguna discapacidad física que pueda dificultar su participación en el entrenamiento?: </b>
                                <label>{props.data ? props.data.physicalDisability : ''}</label>
                            </div>
                            <div className="group-form">
                                <b>TIENES ALGUNA PREGUNTA O INQUIETUD: </b>
                                <label>{props.data ? props.data.questions : ''}</label>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}